module.exports = __webpack_public_path__ + "static/media/pilari.130bb581.png";